import type { VehicleId } from '../../types/gcs/vehicle';
import { getVehicleStatusCategory } from '../../types/ui/vehicleStatusCategory';
import type { VehicleStatusCategory } from '../../types/ui/vehicleStatusCategory';
import type { GcsData } from '../../types/gcs/gcsData';
import { selectVehicleStatus } from './selectVehicleStatus';

/**
 * Selector to get the vehicle status category for a specific vehicle
 * @param data - The GCS data map from the store
 * @param gcsId - The GCS ID
 * @param vehicleId - The vehicle ID
 * @returns The vehicle status category or null if data is not available
 */
export function selectVehicleStatusCategory(
  data: Map<string, GcsData>,
  gcsId: string,
  vehicleId: VehicleId
): VehicleStatusCategory | null {
  const vehicleStatus = selectVehicleStatus(data, gcsId, vehicleId);
  if (!vehicleStatus) return null;

  return getVehicleStatusCategory(vehicleStatus);
}
